import React, { useState } from 'react';
import { FaSlidersH, FaBirthdayCake } from 'react-icons/fa';
import { useAuthState } from 'react-firebase-hooks/auth';
import { deleteUserDocument } from '@services/firebaseUser';
import { getFirebase } from '@services/firebase';
import { useAlert } from '../contexts/ToastContext';
import HomeProfileCard from '@components/HomeProfileCard';
import HomeProfileCardLarge from '@components/HomeProfileCardLarge';
import { useProfileActions } from '../hooks/useProfileActions';
import ProcessGuidePanel from '@components/ProcessGuidePanel';

const FAVOURITE_BUYER_STEPS = [
  { label: 'Open Profile',      sub: 'View full details & pricing'                                },
  { label: 'Add to Enquiry',    sub: 'Start enquiry and order',          icon: <FaBirthdayCake />, final: true },
  { label: 'Add to Custom',     sub: 'Customise your requirement',       icon: <FaSlidersH />,    or: true    },
];

const { auth } = getFirebase();

const Favourites = () => {
  const showAlert = useAlert();
  const [user] = useAuthState(auth);
  const [selectedProfile, setSelectedProfile] = useState(null);
  const [showLargeCard, setShowLargeCard] = useState(false);

  const {
    userRole,
    favourites,
    addToCustom,
    isInCustom,
    isInEnquiry,
  } = useProfileActions();

  const handleDelete = async (docId) => {
    if (!user) return;
    try {
      await deleteUserDocument('favourites', user.uid, docId);
    } catch (err) {
      console.error('Failed to delete favourite:', err);
      showAlert('Failed to delete favourite');
    }
  };

  const shareProfile = (profile) => {
    const shareText = `${profile.cflavour} - Filling: ${profile.cfilling1 || profile.cfilling}, ${profile.cfilling2}${profile.ccost ? ` - Cost: ${profile.ccost}` : ''}`;
    if (navigator.share) {
      navigator.share({ title: profile.cflavour, text: shareText, url: window.location.href })
        .catch(console.error);
    } else {
      navigator.clipboard.writeText(shareText).then(() => {
        showAlert('Copied to clipboard!');
      });
    }
  };

  const openLargeCard = (profile) => {
    if (user) {
      setSelectedProfile(profile);
      setShowLargeCard(true);
    }
  };

  const closeLargeCard = () => {
    setShowLargeCard(false);
    setSelectedProfile(null);
  };

  if (!user) {
    return <div className="favourite-page"><p>Please log in ...</p></div>;
  }

  if (favourites === undefined) {
    return <div className="favourite-page"></div>;
  }

  if (favourites.length === 0) {
    return (
      <div className="favourite-page">
        <p style={{ textAlign: 'center', color: '#888', marginTop: '40px' }}>
          No Favourites yet...!
        </p>
      </div>
    );
  }

  return (
    <div className="favourite-page">
      <ProcessGuidePanel steps={FAVOURITE_BUYER_STEPS} userRole={userRole}>
        <div className="card-container">
        {(
          favourites.map(profile => (
            <div key={profile.id} className="profile-card-wrapper">
              <HomeProfileCard
                theme={profile.theme || 'Custom'}
                flavour={profile.cflavour}
                filling={profile.cfilling || profile.cfilling1}
                cover={profile.cover}
                image={profile.cimage}
                showDeleteIcon={true}
                showCustomIcon={true}
                isInCustom={isInCustom(profile.globalId || profile.id)}
                isInFavourites={true}
                onDelete={() => handleDelete(profile.id)}
                onAddToCustom={() => addToCustom(profile)}
                onClick={() => openLargeCard(profile)}
                userRole={userRole}
                profileId={profile.globalId || profile.id}
              />
            </div>
          ))
        )}
        </div>
      </ProcessGuidePanel>

      {showLargeCard && selectedProfile && (
        <HomeProfileCardLarge
          theme={selectedProfile.theme || 'Custom'}
          flavour={selectedProfile.cflavour}
          filling={selectedProfile.cfilling || selectedProfile.cfilling1}
          cover={selectedProfile.cover}
          sponge={selectedProfile.sponge}
          cost={selectedProfile.ccost}
          image={selectedProfile.cimage}
          cshape={selectedProfile.cshape}
          onClose={closeLargeCard}
          onShare={() => shareProfile(selectedProfile)}
          onAddToCustom={() => addToCustom(selectedProfile)}
          isInCustom={isInCustom(selectedProfile.globalId || selectedProfile.id)}
          isInFavourites={true}
          isInEnquiry={isInEnquiry(selectedProfile.globalId || selectedProfile.id)}
          user={user}
          userRole={userRole}
          profileId={selectedProfile.globalId || selectedProfile.id}
          fromFavourites={true}
          isVisible={true}
        />
      )}
    </div>
  );
};

export default Favourites;